import Noty from 'noty';
import 'noty/lib/noty.css';
import 'noty/lib/themes/mint.css';
// import { Alert } from 'bootstrap';

export function showErrorNotification(message) {
    new Noty({
        type: 'error',
        layout: 'topRight',
        theme: 'mint',
        text: message,
        timeout: 3000,
        callbacks: {
            onTemplate: function () {
                this.barDom.style.fontFamily = 'inherit';
                this.barDom.style.fontSize = '60px';
                this.barDom.style.backgroundColor = '#cf1141';
                this.barDom.style.border = '1px solid #cf1141';
                this.barDom.style.borderRadius = '10px';
            }
        }
    }).show();
}
